import api from './api';

export interface Portfolio {
  id: number;
  code: string;
  name: string;
  client_entity?: string | null;
  contact_name?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  billing_trigger?: string | null;
  billing_criteria?: string | null;
  color?: string | null;
  notes?: string | null;
  is_active: boolean;
}

export interface PortfolioSummary extends Portfolio {
  cases_total: number;
  cases_active: number;
  cases_closed: number;
  cases_with_radicado: number;
  cases_pending_radicado: number;
  total_amount: number;
  green: number;
  yellow: number;
  red: number;
  gray: number;
}

const portfoliosService = {
  async list(includeInactive = false): Promise<Portfolio[]> {
    const r = await api.get('/portfolios', { params: { include_inactive: includeInactive } });
    return r.data.data || [];
  },
  async summary(): Promise<PortfolioSummary[]> {
    const r = await api.get('/portfolios/summary');
    return r.data.data || [];
  },
  async getById(id: number): Promise<PortfolioSummary> {
    const r = await api.get(`/portfolios/${id}`);
    return r.data.data;
  },
  async listCases(id: number): Promise<any[]> {
    const r = await api.get(`/portfolios/${id}/cases`);
    return r.data.data || [];
  },
  async create(data: Partial<Portfolio>): Promise<Portfolio> {
    const r = await api.post('/portfolios', data);
    return r.data.data;
  },
  async update(id: number, data: Partial<Portfolio>): Promise<Portfolio> {
    const r = await api.patch(`/portfolios/${id}`, data);
    return r.data.data;
  },
  async remove(id: number): Promise<void> {
    await api.delete(`/portfolios/${id}`);
  },
  async downloadExcel(id: number | 'all'): Promise<void> {
    const r = await api.get(`/portfolios/export/${id}`, { responseType: 'blob' });
    const cd = r.headers['content-disposition'] || '';
    const m = /filename="?([^";]+)"?/.exec(cd);
    const filename = m ? m[1] : `cartera_${id}.xlsx`;
    const url = URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
};

export default portfoliosService;
